import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Form */}
      <div className="flex flex-col justify-center px-6 py-10 sm:px-12 lg:px-20">
        <div className="mx-auto w-full max-w-sm">
          <Link to="/" className="mb-10 flex items-center gap-2.5">
            <img src="/better-days-mark.png" alt="Better Days" className="h-6 w-auto" />
            <span className="text-[15px] font-bold tracking-tight text-ink">Better Days</span>
          </Link>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-2xl font-bold tracking-tight text-ink">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-muted">{subtitle}</p>}
            <div className="mt-8">{children}</div>
            {footer && <div className="mt-6 text-sm text-muted">{footer}</div>}
          </motion.div>
        </div>
      </div>
      {/* Visual */}
      <div className="relative hidden overflow-hidden bg-ink lg:block">
        <img src="https://images.unsplash.com/photo-1744060204728-f68e434a3edf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Better Days" className="absolute inset-0 h-full w-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-tr from-ink via-ink/50 to-transparent" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <p className="max-w-md text-2xl font-semibold leading-snug tracking-tight">
            One account. Your bloodwork, coaching, nutrition and training — unified across web and mobile.
          </p>
          <p className="mt-4 text-sm text-white/60">Better Days · AI-powered health optimization</p>
        </div>
      </div>
    </div>
  );
}
